export default function stripeForm() {

    class StripeFormCtrl {
        // @ngInject
        constructor($scope, stripeCheckout, stripeData, stripeCvcFilter) {
            this.registerField = function(name, ngModel) {
                stripeCheckout.fields[name] = ngModel;
            };

            $scope.stripeData = stripeData;
            $scope.stripeData.cvc = stripeCvcFilter('Unknown');

            $scope.$watch(() => stripeData.brand, (brand) => {
                stripeData.cvc = stripeCvcFilter(brand);
            });
        }
    }

    return {
        controller: StripeFormCtrl,
        require: 'form'
    };
}



// WEBPACK FOOTER //
// ./stripe/directives/stripe-form.js